import * as React from 'react'
import { type Character, type Report, type Fight } from '@/lib/api'

export type AnalysisFlowStep = 'search' | 'reports' | 'analysis'

interface AnalysisFlowState {
  step: AnalysisFlowStep
  character: Character | null
  report: Report | null
  fight: Fight | null
}

export const useAnalysisFlow = () => {
  const [state, setState] = React.useState<AnalysisFlowState>({
    step: 'search',
    character: null,
    report: null,
    fight: null,
  })

  const setCharacter = (character: Character) => {
    setState({
      step: 'reports',
      character,
      report: null,
      fight: null,
    })
  }

  const setFight = (report: Report, fight: Fight) => {
    setState(prev => ({
      ...prev,
      step: 'analysis',
      report,
      fight,
    }))
  }

  const goToSearch = () => {
    setState({
      step: 'search',
      character: null,
      report: null,
      fight: null,
    })
  }

  const goToReports = () => {
    setState(prev => ({
      ...prev,
      step: 'reports',
      report: null,
      fight: null,
    }))
  }

  const reset = () => {
    setState({
      step: 'search',
      character: null,
      report: null,
      fight: null,
    })
  }

  return {
    ...state,
    setCharacter,
    setFight,
    goToSearch,
    goToReports,
    reset,
  }
}